import React from "react";
import { Container, Input, Span } from "./styles";
import { BiSortAlt2 } from "react-icons/bi";
import Button from "../../button";

interface IProps {
  // eslint-disable-next-line no-unused-vars
  onChange: (searchTerm: string) => void;
  value: string;
  environmentsLength: number;
}

function SearchComponent(props: IProps) {

  return (
    <Container>
      <Input
        type="text"
        placeholder="Pesquisar"
        value={props.value}
        onChange={(event) => props.onChange(event.target.value)}
      />
      <Button>
        <BiSortAlt2 size={22} color="#000000de" />
      </Button>
      <Span>{props.environmentsLength} ambientes</Span>
    </Container>
  );
}

export default SearchComponent;
